// extracted by mini-css-extract-plugin
module.exports = {"container":"CloudUploadIcon_container__tBGxT"};